export function getDeviceType() {
    let width = $(window).width();
    if (width < 768 ) {
        return 'mobile';
    } else if (width >= 768 && width <= 992) {
        return 'tablet';
    } else {
        return 'desktop';
    }
}